module.exports = __webpack_public_path__ + "img/save_blue.6d44dfaf.svg";